import React from "react"
import CustomTable from "../../components/CustomTable";
import { addHobbiesName, editHobbiesName, getAllHobbiesAndInterests, hobbiesUpdateApprovedAndUnapproved } from "../../services/ApiServices";
import { ApprovedAndUnApprovedBtn } from "../../components/ApprovedAndUnApprovedBtn";
import { EditButton } from "../../components/masterDataForm/EditButton";
// import EditMasterForm from "../../components/masterDataForm/EditMasterForm";
import { AddButton } from "../../components/masterDataForm/AddButton";
// import AddMasterForm from "../../components/masterDataForm/AddMasterForm";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import EditMasterFormWithCountryCode from "../../components/masterDataForm/EditMasterFormWithCountryCode";
import AddMasterDataWithCountryCode from "../../components/masterDataForm/AddMasterDataWithCountryCode";
const HobbiesAndInterets = () => {

    const dispatch = useDispatch();
    const hobbiesInfo = useSelector(state => state?.getAllHobbies?.hobbies);

    const [showAddHobbies, setAddHobbiesShow] = React.useState(false);
    const [showHobbiesAndInterets, setHobbiesAndInteretsShow] = React.useState(false);
    const [hobbiesValName, setHobbiesValName] = React.useState();


    React.useEffect(() => {
        const fetchUsers = async () => {
            try {
                const res = await getAllHobbiesAndInterests();
                dispatch({ type: 'GET_ALL_HOBBIES', payload: res.data.data})
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };
        fetchUsers();
    }, [dispatch]);

    const addHobbiesHandle = async (hobbiesName) => {
        try {
            const addHobbiesNames = await addHobbiesName(hobbiesName);
            if(addHobbiesNames.status === 200) {
                dispatch({ type: 'ADD_HOBBIES_NAME', payload: addHobbiesNames.data?.data})
                toast.success(addHobbiesNames.data?.message)
            }
        } catch (error) {
            toast.error(error.response?.data?.message)
        }
    };
    const editHobbiesHandle = async (hobbies) => {
        try {
            // const hobbiesPayload = {
            //     hobbiesId: hobbies?.statusId,
            //     name: hobbies?.name
            // }
            const hobbiesPayload = {
                hobbiesId: hobbies?.statusId,
                name: hobbies?.name,
                isoCode: hobbies?.isoCode
            }
            const editHobbiesNames = await editHobbiesName(hobbiesPayload);
            if(editHobbiesNames.status === 200) {
                dispatch({ type: 'UPDATE_HOBBIES_NAME', payload: editHobbiesNames.data?.data})
                toast.success(editHobbiesNames.data?.message)
            }
        } catch (error) {
            toast.error(error.response?.data?.message)
        }
    };

    const hobbiesApprovedAndUnAprooved = async (hobbiesId) => {
        try {
            const approvedAndUnapprovedStatus = await hobbiesUpdateApprovedAndUnapproved(hobbiesId);
            if(approvedAndUnapprovedStatus.status === 200) {
                dispatch({ type: 'UPDATE_HOBBIES_STATUS', payload: approvedAndUnapprovedStatus.data?.data})
                toast.success(approvedAndUnapprovedStatus.data?.message)
            }
        } catch (error) {
            toast.error(error.response?.data?.message)
        }

    };

    const colDefs = [
            { field: "name", flex: 2, headerName: 'Name' },
            { field: "isApproved", flex: 2, headerName: 'Status', cellRenderer: (val) => {
            return ( <ApprovedAndUnApprovedBtn status={val?.data?.isApproved} statusId={val.data._id} handleApprovedAndUnAprooved={hobbiesApprovedAndUnAprooved}/> )
            }
        },
            { field: '_id', flex: 2, headerName: 'Action', cellRenderer: (val) => ( <EditButton name={val.data.name} statusId={val.data._id} isoCode={val.data?.isoCode} hadnleEditName={setHobbiesValName} handleEditBtn={setHobbiesAndInteretsShow} />) }
        ];
    return(
        <React.Fragment>
            <div className="aside-heading">
                <h3>Hobbies And Interests</h3>
            </div>
            <AddButton formName="Hobbies" handleAddBtn={setAddHobbiesShow}  />
            <CustomTable colDefs={colDefs} rowData={hobbiesInfo} />
            <AddMasterDataWithCountryCode formName="Hobbies" addMasterData={addHobbiesHandle} showAddForm={showAddHobbies} setShowAddForm={setAddHobbiesShow} />
            <EditMasterFormWithCountryCode formName="Hobbies" editMasterDataName={hobbiesValName} editMasterData={editHobbiesHandle} showEditForm={showHobbiesAndInterets} setShowEditForm={setHobbiesAndInteretsShow}/>
        </React.Fragment>
    )
};
export default HobbiesAndInterets;